import type {UpdateResourceStatusSchema} from '@cypro/engine/mutators'
import {useUpdateActiveSubstanceStatus} from '@/modules/drug-catalog/substances/api'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useActiveSubstanceDrugContext} from '@/shared/contexts/active-substance-drug'
import {LuFlaskConical} from 'react-icons/lu'

export function SubstanceSummary() {
  const {activeSubstanceDrug} = useActiveSubstanceDrugContext()
  const updateStatus = useUpdateActiveSubstanceStatus()
  const canManageCatalogue = useCan('catalogue.manage')

  return (
    <ResourceDrawerSummary
      title={activeSubstanceDrug.name}
      description={activeSubstanceDrug.code}
      icon={LuFlaskConical}
      status={activeSubstanceDrug.status}
      {...(canManageCatalogue
        ? {
            onChangeStatus: (status: UpdateResourceStatusSchema['status']) =>
              updateStatus({id: activeSubstanceDrug.id, status}),
          }
        : {})}
    />
  )
}
